import Vuex from 'Vuex'
import Vue from 'vue'
import createPersistedState from 'vuex-persistedstate'
import defaultState from './state/state'
import mutations from './mutations/mutations'
import actions from './actions/actions'
import getters from './getters/getters'
Vue.use(Vuex)

let key = 'superSign'
let state = {}
try {
  state = JSON.parse( sessionStorage.getItem('superSign') )
} catch (error) {
  
}
Object.assign(defaultState,state)
// console.log(state,defaultState)

const store = new Vuex.Store({
// export default new Vuex.Store({
  plugins: [
    // createPersistedState({   //不知道为什么没生效
		// 	key:"caojiqian",
		// }),
  ],
  state: defaultState,
  mutations,
  getters,
  actions,
})

store.watch(
  state => state,
  val => {
    sessionStorage['superSign'] = JSON.stringify(val) 
  },{
    deep: true,
  },
)

export default store


// if (module.hot) {
//   /* eslint-disable */
//   //Vuex热更新
//   module.hot.accept([
//     './state/state.js',
//     './mutations/mutations.js',
//     './getters/getters.js',
//     './actions/actions.js'
//   ], () => {
//     const newState = require('./state/state').default
//     const newMutations = require('./mutations/mutations').default
//     const newGetters = require('./getters/getters').default
//     const newActions = require('./actions/actions').default
//     store.hotUpdate({
//       state: newState,
//       mutations: newMutations,
//       getters: newGetters,
//       actions: newActions
//     })
//   })
// }



// WEBPACK FOOTER //
// ./src/store/store.js